const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M118.848 84.844H1.15016C0.764119 84.844 0.403639 84.6523 0.191442 84.3302C-0.020755 84.008 -0.0591042 83.6015 0.0891781 83.2462L26.0565 21.6093C26.2354 21.1824 26.6547 20.9062 27.1175 20.9062H72.7603C73.3969 20.9062 73.9108 21.4201 73.9108 22.0567C73.9108 22.6933 73.3969 23.2072 72.7603 23.2072H27.8819L2.88353 82.5431H117.115L98.9756 39.4901C98.7276 38.9046 99.0037 38.2297 99.5892 37.9817C100.175 37.7363 100.85 38.0098 101.098 38.5953L119.909 83.2462C120.06 83.6015 120.021 84.008 119.807 84.3302C119.595 84.6523 119.234 84.844 118.848 84.844Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 84.844C59.3635 84.844 58.8496 84.3302 58.8496 83.6936V22.0567C58.8496 21.4201 59.3635 20.9062 60.0001 20.9062C60.6367 20.9062 61.1505 21.4201 61.1505 22.0567V83.6936C61.1505 84.3302 60.6341 84.844 60.0001 84.844Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3024 84.8447C95.8217 84.8447 95.3718 84.5405 95.2107 84.0598L89.0365 65.6217C88.8346 65.0184 89.1592 64.3664 89.7626 64.1645C90.3634 63.9625 91.0179 64.2872 91.2199 64.8905L97.394 83.3287C97.596 83.932 97.2713 84.584 96.668 84.7859C96.5452 84.8268 96.4225 84.8447 96.3024 84.8447Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7044 84.8442C23.5842 84.8442 23.4589 84.8238 23.3388 84.7854C22.7354 84.5835 22.4107 83.9315 22.6127 83.3282L43.2495 21.6913C43.4515 21.088 44.1034 20.7633 44.7068 20.9652C45.3101 21.1672 45.6348 21.8191 45.4328 22.4225L24.796 84.0593C24.635 84.54 24.185 84.8442 23.7044 84.8442Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7642 40.1935H19.963C19.3264 40.1935 18.8125 39.6796 18.8125 39.043C18.8125 38.4065 19.3264 37.8926 19.963 37.8926H72.7642C73.4008 37.8926 73.9147 38.4065 73.9147 39.043C73.9147 39.6796 73.4008 40.1935 72.7642 40.1935Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.081 66.4064H8.92C8.28341 66.4064 7.76953 65.8925 7.76953 65.2559C7.76953 64.6193 8.28341 64.1055 8.92 64.1055H111.081C111.718 64.1055 112.232 64.6193 112.232 65.2559C112.232 65.8925 111.715 66.4064 111.081 66.4064Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.712 107.656H17.2911C16.6545 107.656 16.1406 107.142 16.1406 106.506V96.0724C16.1406 95.4358 16.6545 94.922 17.2911 94.922H45.5031V83.6934C45.5031 83.0568 46.017 82.543 46.6536 82.543C47.2901 82.543 47.804 83.0568 47.804 83.6934V96.0724C47.804 96.709 47.2901 97.2229 46.6536 97.2229H18.4416V105.355H101.561V97.2229H73.3495C72.7129 97.2229 72.199 96.709 72.199 96.0724V83.6934C72.199 83.0568 72.7129 82.543 73.3495 82.543C73.9861 82.543 74.4999 83.0568 74.4999 83.6934V94.922H102.712C103.349 94.922 103.862 95.4358 103.862 96.0724V106.506C103.862 107.142 103.346 107.656 102.712 107.656Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38 61.3621C95.3305 61.3621 88.2641 59.1174 83.8386 54.5386C77.1761 47.646 78.0709 36.7524 78.7893 28.0012C79.2802 22.0162 79.7455 16.3661 77.5775 14.0371C77.2426 13.6766 77.1736 13.1422 77.4062 12.7076C77.6389 12.273 78.1246 12.0378 78.6104 12.1196C88.2078 13.743 101.799 19.6769 108.515 31.064C113.434 39.4061 113.935 49.3129 110.003 60.5056C109.847 60.9479 109.44 61.2522 108.972 61.2726C107.738 61.334 106.539 61.3621 105.38 61.3621ZM80.7017 14.8858C81.9058 18.1685 81.5172 22.8982 81.0826 28.1903C80.3668 36.9109 79.5538 46.7972 85.4927 52.9407C89.8389 57.4377 97.2352 59.4242 108.085 59.01C111.509 48.7913 110.987 39.7845 106.533 32.2349C100.773 22.4636 89.5449 16.9464 80.7017 14.8858Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredit);
export default __webpack_public_path__ + "static/media/icon-credit.c0d18f023e7dd0432b9a5b2d2f44f3a2.svg";
export { ForwardRef as ReactComponent };